import React from "react";
import { Link } from "react-router-dom";
import InnerNavigation from "../../components/general/InnerNavigation";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Wrapper from "../../components/general/Wrapper";
import styled from "styled-components";

const BackButtonWrap = styled.div`
  display: flex;
  gap: 1.25rem;
  & a {
    text-decoration: none;
  }
`;
const BackButton = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 200px;
  color: #337E84;
  margin-top: 2rem;
  margin-bottom: 2rem;
  
  & span {
    margin-left: 50px;
  }
  & svg {
    position: absolute;
    left: 1%;
    color: white;
    z-index: 1;
  }
  &::after {
    content: "";
    position: absolute;
    z-index: 0;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background-color:#337E84;
    left: 0;
    font-size: 1rem;
  }
`;


function Politics() {
  return (
    <div className="mt-20">
      {/* 2nd navbar */}
      <InnerNavigation
        actualPage={"Política de Investimento"}
        routerLinks={
          <div className="flex gap-5 text-Gray font-semibold">
            <Link to={"/investors"} className="hover:text-Salmon">
              Para Investidores
            </Link>
          </div>
        }
      />

      
      <Wrapper>

      <BackButtonWrap>
        <Link to="/about#strategy">
          <BackButton>
            <KeyboardArrowLeftIcon />
            <span>Voltar</span>
          </BackButton>
        </Link>
      </BackButtonWrap>
        {/* Card Política de Investimento */}
        <div className="mb-20 py-10 px-10 bg-Light rounded-lg">
          <h3 className="text-4xl font-bold text-center text-darkGreen mt-5">
            Política de Investimento
          </h3>
          <p className="text-Gray text-center my-10 sm:mx-20 leading-8 text-lg">
            A “Política de Investimento” espelha a definição pela Vipa Capital
            (VC - SGPS, Lda.) dos princípios basilares a serem aplicados
            transversalmente no grupo societário que encabeça, no âmbito do
            investimento em startups nas fases{" "}
            <span className="text-Gray font-semibold">
              Pré-Seed, Seed e Early Stage{" "}
            </span>{" "}
            que promovam um investimento de impacto localizadas{" "}
            <span className="text-Gray font-semibold">em Portugal.</span>
          </p>
          {/* <p className="text-Gray text-center mt-10">Consulte o PDF completo</p>
          <div className="flex items-center mt-3 justify-center gap-2 text-Gray ">
            <FileCopyIcon />
            <p className="font-bold uppercase text-sm">
              Política de Investimento VCapital
            </p>
          </div> */}
        </div>
      </Wrapper>
    </div>
  );
}

export default Politics;
